import type { MongoAbility } from '@casl/ability';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Fragment } from 'react';

import { GlobalSnackbar } from '@/components/display/GlobalSnackbar';
import type { AppAbilityTuple } from '@/hooks/useAbility';
import { createAbility } from '@/hooks/useAbility';
import type { User } from '@/modules/api/backend';
import {
  backendApiAuthenticationGetUserOptions,
  backendApiCaslGetRulesOptions,
} from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  user: User;
  ability: MongoAbility<AppAbilityTuple>;
  breadcrumb?: string;
}>()({
  beforeLoad: async ({ context: { queryClient } }) => {
    try {
      const user = await queryClient.ensureQueryData(backendApiAuthenticationGetUserOptions());
      const { rules } = await queryClient.ensureQueryData(backendApiCaslGetRulesOptions());

      const ability = createAbility(rules);

      return {
        user,
        ability,
      };
    } catch (error) {
      if (error && typeof error === 'object' && 'statusCode' in error && error.statusCode === 401) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return { user: undefined!, ability: undefined! };
      }

      throw error;
    }
  },

  component: () => (
    <Fragment>
      <Outlet />
      <GlobalSnackbar />
      {/* <TanStackRouterDevtools /> */}
    </Fragment>
  ),
});
